module.exports = __webpack_public_path__ + "assets/img/L-AP_PRO-IC.68deaf59.png";